import { type FC } from 'react';

/**
 * SkipLink - first focusable element; jumps past the navigation to <main id="main-content">.
 */
export const SkipLink: FC = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:rounded focus:bg-bg-tertiary focus:text-text-primary"
  >
    Skip to content
  </a>
);
